import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import BasketDesktop from "./BasketDesktop";
import BasketMobile from "./BasketMobile";

function Basket({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <BasketMobile app={app} config={config} />
  ) : (
    <BasketDesktop app={app} config={config} />
  );
}

Basket.defaultProps = {
  app: null,
  config: {},
};

Basket.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Basket;
